import IframeContainer from "./features/iframe-container";
import License from "./features/license";
import './styles.css';


(() => {
    /**
     * License validation - must run first.
     */
    License()

    /**
     * Iframe Container - wraps page in iframe for SPA navigation
     */
    if ( ajaxpress_vars.settings.enable_navigation ) {
        IframeContainer()
    }
})()
